document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-obp-small-accessory]').forEach((section) => {
    const form = section.querySelector('[data-obp-sa-form]');
    const sticky = section.querySelector('[data-obp-sa-sticky-button]');
    const message = section.querySelector('[data-obp-sa-message]');
    if (!form) return;

    const submit = form.querySelector('button[type="submit"]');
    const add = async () => {
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      if (sticky) sticky.disabled = true;
      if (message) message.textContent = 'Wird zum Warenkorb hinzugefügt …';
      const variantId = Number(form.querySelector('[name="id"]')?.value);
      try {
        const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('cart');
        const result = await response.json();
        if (message) message.textContent = 'Zum Warenkorb hinzugefügt.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: result.items?.[0] || result } }));
        setTimeout(() => document.getElementById('Cart-Drawer')?.open?.(), 120);
      } catch (_) {
        form.submit();
      } finally {
        submit.disabled = false;
        if (sticky) sticky.disabled = false;
      }
    };

    form.addEventListener('submit', (event) => { event.preventDefault(); add(); });
    sticky?.addEventListener('click', add);
    section.querySelectorAll('.obp-sa__faq details').forEach((details) => {
      details.addEventListener('toggle', () => {
        const icon = details.querySelector('summary i');
        if (icon) icon.textContent = details.open ? '×' : '+';
      });
    });
  });
});
